import { call, all, put, takeLatest, takeEvery } from "redux-saga/effects";

import {
  GET_QUOTE_LIST,
  GET_QUOTE_DETAILS,
  CREATE_QUOTE,
  UPDATE_QUOTE,
  DELETE_QUOTE,
  GET_QUOTE_STATUS_LIST,
  GET_QUOTE_PDF,
  ADD_NEW_QUOTE_STATUS,
  UPDATE_QUOTE_STATUS,
  DELETE_QUOTE_STATUS,
  GET_SINGLE_CUSTOMER_QUOTE_LIST,
} from "./actionType";

import {
  getQuoteListSuccess,
  getQuoteListFailure,
  getQuoteDetailsSuccess,
  getQuoteDetailsFailure,
  createQuoteSuccess,
  createQuoteFailure,
  updateQuoteSuccess,
  updateQuoteFailure,
  deleteQuoteSuccess,
  deleteQuoteFailure,
  getQuoteStatusListSuccess,
  getQuoteStatusListFailure,
  getQuotePDFSuccess,
  getQuotePDFFailure,
  addNewQuoteStatusSuccess,
  addNewQuoteStatusFailure,
  updateQuoteStatusSuccess,
  updateQuoteStatusFailure,
  deleteQuoteStatusSuccess,
  deleteQuoteStatusFailure,
  getSingleCustomerQuoteListSuccess,
  getSingleCustomerQuoteListFailure,
} from "./action";

import {
  getQuoteListApiCall,
  getSingleQuoteDataApiCall,
  createSingleQuoteApiCall,
  updateSingleQuoteApiCall,
  deleteSingleQuoteApiCall,
  getQuoteStatusListApiCall,
  getQuoteTypeListApiCall,
  addNewQuoteStatusApiCall,
  updateQuoteStatusApiCall,
  deleteQuoteStatusApiCall,
  getSingleCustomerQuoteListApiCall,
} from "../../helpers/fakebackend_helper";

// Get Quote List
function* getQuoteListSaga() {
  try {
    const response = yield call(getQuoteListApiCall);
    yield put(getQuoteListSuccess(response));
  } catch (error) {
    yield put(getQuoteListFailure(error));
  }
}

// Watcher for Get Quote List
export function* watchGetQuoteListSaga() {
  yield takeLatest(GET_QUOTE_LIST, getQuoteListSaga);
}

// Get Quote Details
function* getQuoteDetailsSaga({ payload: data }) {
  try {
    const response = yield call(getSingleQuoteDataApiCall, data);
    yield put(getQuoteDetailsSuccess(response));
  } catch (error) {
    yield put(getQuoteDetailsFailure(error));
  }
}

// Watcher for Get Quote Details
export function* watchGetQuoteDetailsSaga() {
  yield takeLatest(GET_QUOTE_DETAILS, getQuoteDetailsSaga);
}

// Create Quote
function* createQuoteSaga({ payload: data }) {
  try {
    const response = yield call(createSingleQuoteApiCall, data);
    yield put(createQuoteSuccess(response));
  } catch (error) {
    yield put(createQuoteFailure(error));
  }
}

// Watcher for Create Quote
export function* watchCreateQuoteSaga() {
  yield takeLatest(CREATE_QUOTE, createQuoteSaga);
}

// Update Quote
function* updateQuoteSaga({ payload: data }) {
  try {
    const response = yield call(updateSingleQuoteApiCall, data);
    yield put(updateQuoteSuccess(response));
  } catch (error) {
    yield put(updateQuoteFailure(error));
  }
}

// Watcher for Update Quote
export function* watchUpdateQuoteSaga() {
  yield takeLatest(UPDATE_QUOTE, updateQuoteSaga);
}

// Delete Quote
function* deleteQuoteSaga({ payload: data }) {
  try {
    const response = yield call(deleteSingleQuoteApiCall, data);
    yield put(deleteQuoteSuccess(response));
  } catch (error) {
    yield put(deleteQuoteFailure(error));
  }
}

// Watcher for Delete Quote
export function* watchDeleteQuoteSaga() {
  yield takeLatest(DELETE_QUOTE, deleteQuoteSaga);
}

// Get Quote Status List
function* getQuoteStatusListSaga() {
  try {
    const response = yield call(getQuoteStatusListApiCall);
    yield put(getQuoteStatusListSuccess(response));
  } catch (error) {
    yield put(getQuoteStatusListFailure(error));
  }
}

// Watcher for Get Quote Status List
export function* watchGetQuoteStatusListSaga() {
  yield takeLatest(GET_QUOTE_STATUS_LIST, getQuoteStatusListSaga);
}

// Get Quote PDF
function* getQuotePDFSaga({ payload: data }) {
  try {
    const response = yield call(getQuoteTypeListApiCall, data);
    yield put(getQuotePDFSuccess(response));
  } catch (error) {
    yield put(getQuotePDFFailure(error));
  }
}

// Watcher for Get Quote PDF
export function* watchGetQuotePDFSaga() {
  yield takeLatest(GET_QUOTE_PDF, getQuotePDFSaga);
}

// Add New Quote Status
function* addNewQuoteStatusSaga({ payload: data }) {
  try {
    const response = yield call(addNewQuoteStatusApiCall, data);
    yield put(addNewQuoteStatusSuccess(response));
  } catch (error) {
    yield put(addNewQuoteStatusFailure(error));
  }
}

// Watcher for Add New Quote Status
export function* watchAddNewQuoteStatusSaga() {
  yield takeLatest(ADD_NEW_QUOTE_STATUS, addNewQuoteStatusSaga);
}

// Update Quote Status
function* updateQuoteStatusSaga({ payload: data }) {
  try {
    const response = yield call(updateQuoteStatusApiCall, data);
    yield put(updateQuoteStatusSuccess(response));
  } catch (error) {
    yield put(updateQuoteStatusFailure(error));
  }
}

// Watcher for Update Quote Status
export function* watchUpdateQuoteStatusSaga() {
  yield takeLatest(UPDATE_QUOTE_STATUS, updateQuoteStatusSaga);
}

// Delete Quote Status
function* deleteQuoteStatusSaga({ payload: data }) {
  try {
    const response = yield call(deleteQuoteStatusApiCall, data);
    yield put(deleteQuoteStatusSuccess(response));
  } catch (error) {
    yield put(deleteQuoteStatusFailure(error));
  }
}

// Watcher for Delete Quote Status
export function* watchDeleteQuoteStatusSaga() {
  yield takeLatest(DELETE_QUOTE_STATUS, deleteQuoteStatusSaga);
}

// single customer quote  list
function* getSingleCustomerQuoteListSaga({ payload: data }) {
  try {
    const response = yield call(getSingleCustomerQuoteListApiCall, data);
    yield put(getSingleCustomerQuoteListSuccess(response));
  } catch (error) {
    yield put(getSingleCustomerQuoteListFailure(error));
  }
}

// Watcher for single customer quote  list
export function* watchGetSingleCustomerQuoteListSaga() {
  yield takeLatest(
    GET_SINGLE_CUSTOMER_QUOTE_LIST,
    getSingleCustomerQuoteListSaga
  );
}

// Export Quote Saga
export default function* Quote() {
  yield all([
    watchGetQuoteListSaga(),
    watchGetQuoteDetailsSaga(),
    watchCreateQuoteSaga(),
    watchUpdateQuoteSaga(),
    watchDeleteQuoteSaga(),
    watchGetQuoteStatusListSaga(),
    watchGetQuotePDFSaga(),
    watchAddNewQuoteStatusSaga(),
    watchUpdateQuoteStatusSaga(),
    watchDeleteQuoteStatusSaga(),
    watchGetSingleCustomerQuoteListSaga(),
  ]);
}
